'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Constants


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

var _reactRedux = require('react-redux');

var _defaultDropLocationFn = require('./defaultDropLocationFn');

var _defaultDropLocationFn2 = _interopRequireDefault(_defaultDropLocationFn);

var _elementConstants = require('../../../common/elements/elementConstants');

var _draggingActions = require('../../reducers/draggingActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onHover: function onHover(targetId, targetType) {
            return dispatch((0, _draggingActions.dragOver)(targetId, targetType));
        }
    };
};

var defaultDropCollect = function defaultDropCollect(connector, monitor) {
    return {
        connectDropTarget: connector.dropTarget(),
        isHovered: monitor.canDrop() && monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop()
    };
};

var injectTargetType = function injectTargetType(Element, targetType) {
    return function (props) {
        return _react2.default.createElement(Element, _extends({}, props, { targetType: targetType }));
    };
};

exports.default = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var targetType = arguments[1];
    var customCollect = arguments[2];
    return function (Element) {
        var acceptDropTypes = [_elementConstants.ELEMENT_DND_TYPE];

        if (config && config.acceptDropTypes) {
            acceptDropTypes = acceptDropTypes.concat(config.acceptDropTypes);
            delete config.acceptDropTypes;
        }

        var elementDropTarget = _extends({ drop: _defaultDropLocationFn2.default }, config);

        var dropCollect = customCollect || defaultDropCollect;

        var dropTarget = (0, _reactDnd.DropTarget)(acceptDropTypes, elementDropTarget, dropCollect)(Element);
        return targetType ? (0, _reactRedux.connect)(null, mapDispatchToProps)(injectTargetType(dropTarget, targetType)) : dropTarget;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/ElementDropTarget.js
// module id = 168
// module chunks = 0